export default __webpack_public_path__ + "static/media/stek_dyno_shield.6faaeac3.jpg";